// 字典api
import { axiosPost } from "@/utils/request";

/**
 * 查询所有字典的类型标识
 */
export const findLibrary = (data) => {
  return axiosPost({
    url: "/ap-system/findLibrary",
    data: {
      libraryParentId: "0",
      ...data,
    },
  });
};

/**
 * 查询子集字典根据 parentId
 * @param {*} parentId
 * @returns
 */
export const findChildLibraryByParentId = (parentId) => {
  return axiosPost({
    url: "/ap-system/findLibrary",
    data: {
      libraryParentId: parentId,
      pageIndex: 1,
      pageSize: 1000,
    },
    loading: false,
  });
};
/**
 * 新增字典
 * @param {*} data
 * @returns
 */
export const addLibrary = (data) => {
  return axiosPost({
    url: "/ap-system/saveLibrary",
    data: data,
    tips: true,
  });
};

/**
 * 修改
 * @param {*} data
 * @returns
 */
export const updateLibrary = (data) => {
  delete data.libraryCreatetime;
  return axiosPost({
    url: "/ap-system/modifyLibrary",
    data: data,
    tips: true,
  });
};

/**
 * 删除字典
 * @param {*} libraryId
 * @returns
 */
export const deleteLibrary = (libraryId) => {
  return axiosPost({
    url: "/ap-system/removeLibrary",
    data: {
      libraryId: libraryId,
    },
    tips: true,
  });
};

/**
 * 返回字典表的所有数据
 * @returns {Promise<unknown>}
 */
export const findAllLibrary = () => {
  return axiosPost({
    url: "/ap-system/findLibrary",
    data: {
      pageIndex: 1,
      pageSize: 100000,
    },
  });
};
